export default function ($rootScope, homeownerService, addFormService, deviceService) {
  'ngInject';

  this.isMobile = deviceService.isMobile;

  this.saveDraft = () => {
    addFormService.ad.status = 'draft';
    $rootScope.$broadcast('publish.skipPremoderationCheck');
  };

  // Обработчик клика по кнопке "Я хочу стать агентом"
  this.switchToAgent = () => {
    addFormService.ad.isByHomeowner = false;
    homeownerService.isChangeToAgent = true;
  };
}
